import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../models/role';
import { UserRoleService } from '../services/user-role.service';

@Pipe({
  name: 'access',
  standalone: false
})
export class AccessPipe implements PipeTransform {
  constructor(private readonly userRoleService: UserRoleService) {}

  public transform(roles: Role[]): boolean {
    if (!roles?.length) {
      return true;
    }

    return this.userRoleService.hasRole(roles);
  }
}
